function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1 15a5 5 0 015-5h5a4 4 0 014 4h-2a2 2 0 00-2-2H6a3 3 0 00-3 3v2a3 3 0 003 3h5a2 2 0 002-2h2a4 4 0 01-4 4H6a5 5 0 01-5-5v-2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 16a1 1 0 011-1h14a1 1 0 110 2H9a1 1 0 01-1-1z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 10a5 5 0 015 5v2a5 5 0 01-5 5h-5a4 4 0 01-4-4h2a2 2 0 002 2h5a3 3 0 003-3v-2a3 3 0 00-3-3h-5a2 2 0 00-2 2h-2a4 4 0 014-4h5z",
  fill: "currentColor"
})));